// Available Environments
const DEV = "DEV";
const TFI = "TFI";
const TEST1 = "TEST1";
const STAGE = "STAGE";
const PROD = "PROD";
const STAGE1 = "STAGE1";
const NBANH = "NBANH";
const HHN = "HHN";

const ENV = process.env.REACT_APP_ENV;
const ENV_NAME = process.env.REACT_APP_ENV_NAME;

const WEB_SERVER_PORT = process.env.REACT_APP_WEB_SERVER_PORT;
const NODE_JS_LOCAL = process.env.REACT_APP_NODE_JS_LOCAL ? process.env.REACT_APP_NODE_JS_LOCAL.toLowerCase() === "true" : false;

const AWS_MOBILE = {
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEBCLIENT_ID,
};

const LUKE_API_KEY = process.env.REACT_APP_LUKE_API_KEY;

module.exports = {
  ENV,
  ENV_NAME,
  DEV,
  TFI,
  TEST1,
  STAGE,
  PROD,
  STAGE1,
  NBANH,
  HHN,
  WEB_SERVER_PORT,
  NODE_JS_LOCAL,
  AWS_MOBILE,
  LUKE_API_KEY,
};
